import {
  AfterViewInit,
  Component,
  computed,
  inject,
  Input,
  OnChanges, OnInit,
  SimpleChanges, TemplateRef,
  Type,
  ViewChild
} from '@angular/core';
import {CommonModule, CurrencyPipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DataGridView, DataGridViewCollumn, FilterListEntry, Types} from '../../../Componente/DataGridView';
import {PopUpView} from '../../../Componente/PopUpView';
import {FloatingButtonComponent} from '../../../Componente/floatingButton';
import {DateSelect} from '../../../Akte/Controlls/DateSelect';
import {StatusPipe} from '../../../Pipes/StatusPipe';
import {VersandStepper} from '../../../Componente/versand-stepper/versand-stepper';

import {ToastService} from '../../../Akte/Services/Toasts/ToastService';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {PGFilterService} from '../../Services/PGFilterService';
import {Lauf} from '../../../Api/DcoApi/Abrechnung/Lauf';
import {NotificationService} from '../../../Services/NotificationService';
import {ArtikelEdit} from '../../../Admin/Controlls/EditViews/ArtikelEdit';
import {AktePopup} from '../Status/AktePopup';
import {GeneratingPopup} from './Popups/generating-popup/generating-popup';
import {MissingInbetriebnahmeListe} from './Popups/missing-inbetriebnahme-liste/missing-inbetriebnahme-liste';
import {FileUploadExport} from './Popups/file-upload-export/file-upload-export';
import {Akte_Main} from '../../../Akte/Akte.Main';
import {AbsetzungsStatusPipe} from '../../../Pipes/AbsetzungsStatusPipe';
import {RestClient} from '../../../Api/DcoApi/Client/RestClient';
import {ResubmitCode} from './Popups/resubmit-code/resubmit-code';
import {AbsetzungEntry} from '../../../Api/DcoApi/Abrechnung/Absetzung';
import { AbsetzungsEdit} from './Popups/absetzungs-edit/absetzungs-edit';


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent, StatusPipe, VersandStepper, CurrencyPipe, ArtikelEdit
  ],
  selector: 'Absetzung',
  templateUrl: './Absetzung.html',
  standalone: true,
  styleUrl: './Absetzung.css'
})
export class Absetzung implements OnChanges, AfterViewInit {
  @ViewChild('Grid') childComponent!: DataGridView<Lauf>;
  toastService: ToastService;
  Types = Types;

  @Input() Partner: number | null = null;
  @Input() Lauf: number | null = null;
  @Input() FilterID: number | null = null;
  @Input() Customer: string | null = null;

  @Input() CustomerAsDefaultFilter: boolean = false;
  @Input() HideHeader: boolean = false;
  @Input() DisableUrlFilter: boolean = false;

  @Input() SelectedChanged = (o:any)  => {};

  private modalService = inject(NgbModal);

  protected absetzungsStatusPipe: Type<any> = AbsetzungsStatusPipe;

  apiClinet: RestClient = new RestClient();
  selectedIDs: number[] = [];

  @ViewChild('successVerTpl') public successVerTpl!: TemplateRef<any>;
  @ViewChild('FaildVerTpl') public FaildVerTpl!: TemplateRef<any>;

  FilterList :FilterListEntry[] = [
    {Key:'Alle', Value: null },
    {Key:'SUBMITTED', Value:'0'},
    {Key:'Bezahlt', Value:'1'},
    {Key:'Absetzung korrigiert', Value:'2'},
    {Key:'Absetzung', Value:'3'},
    {Key:'RESUBMITTED', Value:'4'},
    {Key:'Stornieren', Value:'5'},
    {Key:'In Bearbeitung', Value:'6'},
  ]





  dataurl = computed(() => {

    if(this.Customer && this.Customer.length > 0 && !this.CustomerAsDefaultFilter)
      if(this.FilterID && this.FilterID > 0)
        return `/Absetzung/${this.FilterID}/Patient/${this.Customer}/List`
    else
      return `/Absetzung/Patient/${this.Customer}/List`

    if(this.Partner && this.Partner > 0)
      if(this.Lauf && this.Partner > 0)
        return `/Absetzung/${this.Partner}/${this.Lauf}/List`
    else
        return `/Absetzung/${this.Partner}/List`

    if(this.CustomerAsDefaultFilter && this.FilterID && this.FilterID > 0)
      return `/Absetzung/List/${this.FilterID}`
    return `/Absetzung/List`
  })

  protected currencyPipe: Type<any> = CurrencyPipe;

  constructor() {
    this.toastService = inject(ToastService)
  }
  ngAfterViewInit(): void {
    this.childComponent.SelectRowByID(this.FilterID);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['FilterID'])
    {
      this.childComponent.LoadData();
      this.childComponent.SelectRowByID(this.FilterID);
    }
  }

  setWorkInProgress()
  {
    var col = this.childComponent.columns.find(c => c.field == 'status');

    this.childComponent.setColFiletr(col,"6")
  }

 async SetPayed(id:number)
  {
    try {

      await this.apiClinet.Post<any,any>(`/Absetzung/${id}/Payed`,null);

      this.toastService.show({ template: this.successVerTpl, classname: 'bg-success text-light show', delay: 10000 });

    }
    catch (e)
    {
      console.log(e);
      this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
    }
  }


  SetResubmitCode(id:number)
  {
    var modal = this.modalService.open(ResubmitCode,{
      windowClass: 'modal-dialog-500px'
    });
    modal.componentInstance.Key = id;
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
  }

  OpenAkten(kvnummer:string, id:Number)
  {
    var modal = this.modalService.open(AktePopup);
    modal.componentInstance.Key = id;
    modal.componentInstance.versichertenNr = kvnummer;
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
  }

  async OpenAbsetzung(entry: AbsetzungEntry)
  {
    //const { AbsetzungsEdit } = await import('./Popups/absetzungs-edit/absetzungs-edit');

    var modal = this.modalService.open(AbsetzungsEdit);
    modal.componentInstance.Entry.set(entry);
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
  }


}
